import { AboveTheFoldCTA } from "modules/sections/AboveTheFold";
import type { ReactStoryblokComponent } from "types/storyblok";
import type { AboveTheFoldCTAProps } from "modules/sections/AboveTheFold/AboveTheFoldCTA";

const AboveTheFoldCTASectionAdapter = ({
  blok: { srcMobile, alt, srcDesktop, title, subtitle, trustpilot, buttons },
  sbEditable,
}: ReactStoryblokComponent<AboveTheFoldCTAProps>) => (
  <AboveTheFoldCTA
    srcDesktop={srcDesktop}
    alt={alt}
    srcMobile={srcMobile}
    title={title}
    subtitle={subtitle}
    trustpilot={trustpilot}
    buttons={buttons}
    sbEditable={sbEditable}
  />
);
export default AboveTheFoldCTASectionAdapter;
